import { useEffect, useId, useRef } from "react";

// [wallet.release-and-refund](../../../docs/product/wallet-and-credit.md#wallet-release-and-refund) / [items.purchase-stages](../../../docs/product/items.md#items-purchase-stages): work and purchase callers own eligibility, stale-term checks,
// duplicate prevention and settlement. This dialog reports explicit confirmation,
// blocks dismissal while busy, and restores the opening control's focus on close.
export function ReleaseConfirmation({ description, busy, disabled, error, onClose, onConfirm }: {
  description: string;
  busy: boolean;
  disabled: boolean;
  error: string | null;
  onClose: () => void;
  onConfirm: () => void;
}) {
  const titleId = useId();
  const descriptionId = useId();
  const dialog = useRef<HTMLDialogElement>(null);
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    const modal = dialog.current;
    const previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    modal?.showModal();
    heading.current?.focus({ preventScroll: true });
    return () => { modal?.close(); if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true }); };
  }, []);

  return <dialog ref={dialog} aria-labelledby={titleId} aria-describedby={descriptionId}
    onCancel={event => { event.preventDefault(); if (!busy) onClose(); }}
    className="m-auto max-h-[90dvh] w-[calc(100%_-_2rem)] max-w-sm overflow-y-auto rounded-3xl border border-line bg-white p-6 text-center shadow-xl backdrop:bg-navy/50 sm:p-8">
    <h2 ref={heading} tabIndex={-1} id={titleId} className="text-xl font-bold text-navy outline-none">Release payment?</h2>
    <p id={descriptionId} className="mt-3 break-words text-sm leading-6 text-mut">
      {description}
    </p>
    {error && <p role="alert" className="mt-4 break-words text-sm text-brand-red">{error}</p>}
    <div className="mt-6 grid grid-cols-2 gap-3">
      <button type="button" disabled={busy} onClick={onClose} className="btn-outline min-h-11 w-full bg-navy-50 text-sm disabled:opacity-50">Cancel</button>
      <button type="button" disabled={busy || disabled} onClick={onConfirm} className="btn-red min-h-11 w-full text-sm disabled:opacity-50">{busy ? "Releasing…" : "Release"}</button>
    </div>
  </dialog>;
}
